import actions from './actions';
import { defineStore } from "pinia"

function initState() {
    return {
        agents: [],
        totalCount: 0, // init total count 
        total: 0, // current pages 
        allTotal: 0 // init all pages
    };
}

export default (storeName) => defineStore(storeName, {
    state: initState,
    actions
})
